import {
  COMPLETE_KYC,
  COMPLETE_KYC_SUCCESS,
  COMPLETE_KYC_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  kycData: {},
};

const completeKYCReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case COMPLETE_KYC:
      return { ...state, loading: true };
    case COMPLETE_KYC_SUCCESS:
      return {
        ...state,
        kycData: action?.payload,
        loading: false,
      };
    case COMPLETE_KYC_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default completeKYCReducer;
